
import { City } from "@/models/City";
import { Game } from "@/models/Game";
import { ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { cloneDeep, difference, isEqual } from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LanguageSelectCard from "../Base/LanguageSelectCard.vue";
import SavePanel from "../Base/SavePanel.vue";
import PoiChallenge from "./ComposePoiTabs/ManhuntTabs/PoiChallenge.vue";
import PoiDefaultContent from "./ComposePoiTabs/ManhuntTabs/PoiDefaultContent.vue";
import PoiFx from "./ComposePoiTabs/ManhuntTabs/PoiFx.vue";
import PoiGeneral from "./ComposePoiTabs/ManhuntTabs/PoiGeneral.vue";
import PoiMapModifiers from "./ComposePoiTabs/ManhuntTabs/PoiMapModifiers.vue";
import PoiWitness from "./ComposePoiTabs/ManhuntTabs/PoiWitness.vue";
import ClonePoi from "./ComposePoiTabs/PoiAdd/ClonePoi.vue";
import { MapPoiWarning } from "@/models/MapPois/Base/MapPoiWarning";
import WarningsGame from "@/utils/WarningsGame";
import ErrorsGame from "@/utils/ErrorsGame";

@Component({
  components: {
    LanguageSelectCard,
    PoiWitness,
    PoiMapModifiers,
    PoiGeneral,
    PoiFx,
    PoiDefaultContent,
    PoiChallenge,
    SavePanel,
    ClonePoi,
  },
})
class EditPoi extends Vue {
  @Prop({ default: null }) readonly mapKey!: string;
  @Prop({ default: null }) readonly cityData!: City;
  @Prop({ default: null }) readonly gameUid!: string;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  tabPicked = 0;
  showSavePanel = false;
  isSavedOrDiscard = false;
  mapPoiDataClone = {} as ManhuntMapPoi;
  mapPoiObject = {} as ManhuntMapPoi;
  warningObject = {} as MapPoiWarning;
  showPoi = false;

  get getMapPoi(): ManhuntMapPoi {
    return this.$store.state.mapPoiStore.mapPoi.find(
      (x: ManhuntMapPoi) => x.key === this.mapKey
    );
  }

  get getGame(): Game {
    return this.$store.state.gameStore.games.find(
      (x: Game) => x.key == this.gameUid
    );
  }

  get getMapPoiObject(): ManhuntMapPoi {
    return this.mapPoiObject;
  }

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }

  get getMapPoiData(): ManhuntMapPoi[] {
    return this.$store.state.mapPoiStore.mapPoi;
  }

  handleSubmitPressed(): void {
    this.showPoi = true;
  }
  closeDialog(): void {
    this.showPoi = false;
    this.handleClose();
  }
  getTabs(event: any): void {
    this.tabPicked = event;
  }

  get showButton(): boolean {
    if (this.getMapPoi.key === "START_ZONE") {
      return false;
    }
    return true;
  }

  created(): void {
    this.mapPoiObject = cloneDeep(this.getMapPoi);
    this.mapPoiDataClone = cloneDeep(this.getMapPoi);
    this.$store.commit("mapPoiStore/currentlyEditing", false);
    this.$nextTick(function() {
      this.$bvModal.show("team-modal-edit-poi");
    });
  }
  discardChanges(value: boolean): void {
    this.mapPoiObject = cloneDeep(this.getMapPoi);
    this.showSavePanel = false;
    this.getMapPoi;
    this.isSavedOrDiscard = true;
  }

  saveChanges(value: boolean): void {
    try {
      var data = {
        game_uid: this.gameUid,
        mapPoi: this.mapPoiObject,
      };
      if (data.mapPoi.title.en !== "START_ZONE") {
        this.deleteTargetToMapPoi();
        this.addTargetToMapPoi(data.mapPoi.key);
        this.deleteTriggerToMapPoi();
        this.addTriggerToMapPois(data.mapPoi.key);
        this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
        new WarningsGame(
          this.getGame,
          this.gameUid,
          this.getMapPoiData
        ).checkWarningsErrors();
        new ErrorsGame(
          this.gameUid,
          this.getMapPoiData,
          this.getCityData
        ).checkGameErrors();
        this.mapPoiDataClone = cloneDeep(this.mapPoiObject);
      } else {
        this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
      }
      this.showSavePanel = false;
      if (!value) {
        this.isSavedOrDiscard = true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  addTriggerToMapPois(key: string): void {
    if (this.mapPoiObject.map_mods.trigger_list !== undefined) {
      var keys = Object.keys(this.mapPoiObject.map_mods.trigger_list);
      keys.forEach((x: string) => {
        var triggerMapPoi = this.getMapPoiData.find((y) => y.key === x);
        if (triggerMapPoi !== undefined) {
          if (triggerMapPoi.map_mods.targetedBy?.trigger === undefined) {
            triggerMapPoi.map_mods.targetedBy = {
              trigger: {
                [key]: true,
              },
            };
          } else {
            triggerMapPoi.map_mods.targetedBy.trigger![
              key
            ] = this.mapPoiObject.map_mods.trigger_list![x];
          }
          var data = {
            gameUid: this.gameUid,
            targetMapPoi: triggerMapPoi,
          };
          this.$store.dispatch("mapPoiStore/addTargetMapPoi", data);
        }
      });
    }
  }

  deleteTriggerToMapPoi(): void {
    try {
      if (this.mapPoiDataClone.map_mods.trigger_list !== undefined) {
        var oldKeys = Object.keys(this.mapPoiDataClone.map_mods.trigger_list);
        if (this.mapPoiObject.map_mods.trigger_list !== undefined) {
          var newKeys = Object.keys(this.mapPoiObject.map_mods.trigger_list);
          let array = difference(oldKeys, newKeys);
          array.forEach((x) => {
            var triggerMapPoi = this.getMapPoiData.find((y) => y.key === x);
            if (triggerMapPoi !== undefined) {
              delete triggerMapPoi.map_mods.targetedBy!.trigger![
                this.mapPoiObject.key
              ];
              var data = {
                gameUid: this.gameUid,
                targetMapPoi: triggerMapPoi,
              };
              this.$store.dispatch("mapPoiStore/addTargetMapPoi", data);
            }
          });
        } else {
          oldKeys.forEach((x) => {
            var triggerMapPoi = this.getMapPoiData.find((y) => y.key === x);
            if (triggerMapPoi !== undefined) {
              delete triggerMapPoi.map_mods.targetedBy!.trigger![
                this.mapPoiObject.key
              ];
              var data = {
                gameUid: this.gameUid,
                targetMapPoi: triggerMapPoi,
              };
              this.$store.dispatch("mapPoiStore/addTargetMapPoi", data);
            }
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  addTargetToMapPoi(key: string): void {
    if (this.mapPoiObject.map_mods.runaway?.targets !== undefined) {
      var keys = Object.keys(this.mapPoiObject.map_mods.runaway.targets);
      keys.forEach((x: string) => {
        var targetMapPoi = this.getMapPoiData.find((y) => y.key === x);
        if (targetMapPoi !== undefined) {
          if (targetMapPoi.map_mods.targetedBy === undefined) {
            targetMapPoi.map_mods.targetedBy = {
              runaway: {
                [key]: true,
              },
            };
          } else {
            targetMapPoi.map_mods.targetedBy.runaway![
              key
            ] = this.mapPoiObject.map_mods.runaway!.targets![x];
          }
          var data = {
            gameUid: this.gameUid,
            targetMapPoi: targetMapPoi,
          };
          this.$store.dispatch("mapPoiStore/addTargetMapPoi", data);
        }
      });
    }
  }
  deleteTargetToMapPoi(): void {
    try {
      if (this.mapPoiDataClone.map_mods.runaway?.targets !== undefined) {
        var oldKeys = Object.keys(
          this.mapPoiDataClone.map_mods.runaway?.targets
        );
        oldKeys.forEach((x) => {
          if (
            this.mapPoiObject.map_mods.runaway?.targets !== undefined &&
            x in this.mapPoiObject.map_mods.runaway!.targets! == false
          ) {
            var targetMapPoi = this.getMapPoiData.find((y) => y.key === x);
            if (targetMapPoi !== undefined) {
              delete targetMapPoi.map_mods.targetedBy!.runaway![
                this.mapPoiObject.key
              ];
              var data = {
                gameUid: this.gameUid,
                targetMapPoi: targetMapPoi,
              };
              this.$store.dispatch("mapPoiStore/addTargetMapPoi", data);
            }
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  updateTempObject(data: any): void {
    this.mapPoiObject = cloneDeep(data);
    this.isSavedOrDiscard = false;
    if (!isEqual(this.mapPoiObject, this.mapPoiDataClone)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
  }

  handleClose(): void {
    this.$bvModal.hide("team-modal-edit-poi");
    this.$emit("closeEditPoi");
  }
  @Watch("getMapPoi", { deep: true })
  async onPropertyChanged(): Promise<void> {
    this.mapPoiObject = cloneDeep(this.getMapPoi);
  }
}

export default EditPoi;
